import API from "../../../app/api";

export const getOurObsesions = async () => {
  try {
    const res = await API.get("/banners/bottom-content");
    if (!res.data?.success) {
      throw new Error(res.data?.message || "Failed to fetch Our Obsessions");
    }
    return res.data?.data || null;
  } catch (error) {
    console.error("getOurObsesions error:", error);
    return null;
  }
};